const supportedLanguages = ['en', 'fr', 'es', 'de', 'nl', 'ja'];

export default supportedLanguages;
